export default "__VITE_ASSET__CoGdbayr__"